import axiosClient from "../api/axiosClient";
import { CheckNullParams } from "../utils/CheckNullParams";
const orderApi = {
  getOrders: (params) => {
    const url = "order";
    const payload = CheckNullParams(params);
    return axiosClient.get(url, {
      params: payload,
    });
  },

  getOrder: (id) => {
    const url = "order";
    return axiosClient.get(url + "/" + id);
  },

  createOrder: (params) => {
    const url = "order";
    const payload = CheckNullParams(params);
    return axiosClient.post(url, payload);
  },
  updateOrder: (id, payload) => {
    const url = "order/";
    return axiosClient.patch(url + id, payload);
  },
  deleteOrder: (params) => {
    const url = "order";
    console.log("params", params);
    return axiosClient.delete(url, { params });
  },
};

export default orderApi;
